export default "__VITE_ASSET__BoW8SQUU__"